import { selectActiveSortingType } from "features/category/categorySlice";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectAccessories,
  selectAccessoriesLoading,
  fetchFilteredAccessories,
} from "../accessoriesSlice";

export const useFetchAccessories = (activeFilters: any) => {
  const dispatch = useDispatch();

  const accessories = useSelector(selectAccessories);
  const isLoading = useSelector(selectAccessoriesLoading);
  // const activeCategorySortingType = useSelector(selectActiveSortingType);

  useEffect(() => {
    dispatch(
      fetchFilteredAccessories(
        activeFilters
        // activeCategorySortingType
      )
    );
  }, []);

  return { accessories, isLoading };
};
